// extracted by mini-css-extract-plugin
export default {"normal":"Details_normal__+faf+","smallvalue":"Details_smallvalue__j0b-t","main":"Details_main__OmLdU","equal":"Details_equal__0Twnv"};